import { generatePath, Link } from "react-router-dom";
import dummyUserImage from "Assets/images/dummy_user.jpg";
import { userFullName } from "helpers/common";
import { THERAPIST_DETAIL } from "config/paths";
import { CommonToolTip } from "components/Common/Common";

const AssignedTherapistList = ({ data, handleShowAll }) => {
  if (!data?.length) {
    return <p>--</p>;
  }

  const MAX_VISIBLE = 4;
  const visibleTherapists = data.slice(0, MAX_VISIBLE);
  const hasMore = data.length > MAX_VISIBLE;

  return (
    <div className="d-flex gap-2 flex-wrap">
      {visibleTherapists.map((therapist, index) => (
        <div
          key={therapist?.therapistId || index}
          className="d-flex align-items-center gap-10"
        >
          <CommonToolTip
            text={userFullName(therapist?.chatterTemplateMappedTherapist)}
            component={
              <Link
                className="text-dark"
                to={generatePath(THERAPIST_DETAIL, { id: therapist.therapistId })}
                target="_blank"
              >
                <div className="imgWrp flex-shrink-0">
                  <img
                    src={
                      therapist?.chatterTemplateMappedTherapist?.therapist_detail
                        ?.profile_picture || dummyUserImage
                    }
                    alt=""
                    className="img-fluid rounded-circle object-fit-cover"
                    style={{ height: 35, width: 35 }}
                  />
                </div>
              </Link>
            }
          />
        </div>
      ))}

      {hasMore && (
        <Link
          className="align-self-center themeClr"
          onClick={(e) => {
            e.stopPropagation();
            handleShowAll(data)
          }}
        >
          Show All
        </Link>
      )}
    </div>
  );
};

export default AssignedTherapistList;
